import { render, staticRenderFns } from "./dialog_addShopCG.vue?vue&type=template&id=4dc553d0&scoped=true&"
import script from "./dialog_addShopCG.vue?vue&type=script&lang=js&"
export * from "./dialog_addShopCG.vue?vue&type=script&lang=js&"
import style0 from "./dialog_addShopCG.vue?vue&type=style&index=0&id=4dc553d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc553d0",
  null
  
)

export default component.exports